const PREFIX = process.env.REACT_APP_STORAGE_PREFIX;

if (PREFIX) {
    const original = window.localStorage;
    const wrapped = {
        getItem: (k) => original.getItem(PREFIX + k),
        setItem: (k, v) => original.setItem(PREFIX + k, v),
        removeItem: (k) => original.removeItem(PREFIX + k),
        clear: () => original.clear(),
        key: (i) => original.key(i),
        get length() { return original.length; },
    };
    Object.defineProperty(window, 'localStorage', { value: wrapped, configurable: true });
}